import BaseAPIService from './base.service';

export default class AuthAPIService extends BaseAPIService {
  apiBase: string | undefined;
  rootEndpoint: string;

  constructor(apiBase?: string) {
    super();
    this.rootEndpoint = '/api/auth';
    if (apiBase) this.apiBase = apiBase;
  }

  async getNonce(walletAddress: string, chainId: number) {
    try {
      const res = await super.get({
        apiBase: this.apiBase,
        endpoint: `${this.rootEndpoint}/?walletAddress=${walletAddress}&chainId=${chainId}`,
      });
      return res.json();
    } catch (err: any) {
      console.log('AuthAPIService::getNonce:: ', err);
      throw new Error(err.message);
    }
  }

  async login(walletAddress: string, chainId: number, signature: string): Promise<{ token: string }> {
    try {
      const res = await super.post({
        apiBase: this.apiBase,
        endpoint: `${this.rootEndpoint}`,
        data: {
          walletAddress: walletAddress,
          chainId: chainId,
          signature: signature,
        },
      });
      return res.json();
    } catch (err: any) {
      console.log('AuthAPIService::login:: ', err);
      throw new Error(err.message);
    }
  }
}
